import { View } from 'react-native'
import styled from 'styled-components'
import { Button, useButtonHandlers } from '../../../elements/controls'
import messages from '../messages'

const ButtonsRow = styled(View)`
  flex-direction: row;
  justify-content: ${(props) => props.justify};
`

export const FilmButtons = ({ filmSlug, justify = 'flex-start' }) => {
  const { handlers, authStatus } = useButtonHandlers()
  return (
    <ButtonsRow justify={justify}>
      <Button
        variant="primary"
        icon="play-clapboard"
        intlMsg={messages.playTrailer}
        onPress={() => handlers.playTrailer({ slug: filmSlug })}
        mr="smedium"
      />

      {authStatus.hasSubscription && (
        <Button
          variant="white"
          titleColor="black"
          iconColor="black"
          icon="theaters"
          intlMsg={messages.viewDetails}
          onPress={() => handlers.filmDetails({ filmSlug })}
        />
      )}
    </ButtonsRow>
  )
}
